var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ws_page_section"},[_c('div',{staticClass:"ws_frame_box clearfix"},[_c('div',{staticClass:"ws_chat_frame"},[_c('chat-list'),_c('chat-info')],1),_c('div',{staticClass:"ws_tool_frame"},[_c('tool-right-sidebar')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }